import { useCallback, useEffect, useRef } from 'react'; // eslint-disable-next-line @typescript-eslint/no-explicit-any

export var useDebounceCallback = function useDebounceCallback(callback) {
  var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
  var timeout = useRef();
  var cb = useRef(callback); // Update the callback via a ref to always call the latest version

  useEffect(() => {
    cb.current = callback;
  }, [callback]); // Cleanup pending timeouts when unmounting.

  useEffect(() => () => clearTimeout(timeout.current), []);
  return useCallback(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    clearTimeout(timeout.current); // https://github.com/Microsoft/TypeScript/issues/30128#issuecomment-651877225

    timeout.current = window.setTimeout(() => {
      cb.current(...args);
    }, delay);
  }, [delay]);
};
//# sourceMappingURL=useDebounceCallback.js.map